<template>
    <div>
        <v-card>

            <v-card-title>
                <span>{{package.name}} Bonuses</span>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
                <v-btn color="primary" @click="dialog=true">New</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="package.bonuses" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.min_rides }}</td>
                    <td class="text-xs-left">{{ props.item.min_bookings }}</td>
                    <td class="text-xs-left">{{ props.item.min_online_hours }}</td>
                    <td class="text-xs-left">{{ props.item.min_rating }}</td>
                    <td class="text-xs-left">{{ props.item.min_reject_rate }}</td>
                    <td class="text-xs-left">{{ props.item.min_cancellation_rate }}</td>
                    <td class="text-xs-left">{{ props.item.specific_areas }}</td>
                    <td class="text-xs-left">{{ props.item.specific_services }}</td>
                    <td class="text-xs-left">{{ props.item.prise_type }}</td>
                    <td class="text-xs-left">{{ props.item.prise_value }}</td>
                    <td class="text-xs-left">
                        <v-btn color="danger" @click="timeSlices(props.item.id)">Time Slices</v-btn>
                    </td>
                </template>
<!--                <v-alert v-slot:no-results :value="true" color="error" icon="warning">-->
<!--                    Your search for "{{ search }}" found no results.-->
<!--                </v-alert>-->
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    <span class="headline">Add New Bonus</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form ref="form">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field v-model="model.min_rides" label="Min Rides"></v-text-field>
                                    <v-text-field v-model="model.min_bookings" label="Min Bookings"></v-text-field>
                                    <v-text-field v-model="model.min_online_hours" label="Min Online Hours"></v-text-field>
                                    <v-text-field v-model="model.min_rating" label="Min Rating"></v-text-field>
                                    <v-text-field v-model="model.min_reject_rate" label="Min Reject Rate"></v-text-field>
                                    <v-text-field v-model="model.min_cancellation_rate" label="Min Cancellation Rate"></v-text-field>
                                    <v-checkbox color="primary" v-model="model.specific_areas" label="Specific Areas"></v-checkbox>
<!--                                    <choose-area-multi v-model="model.areas" v-if="model.specific_areas" label="Specific Areas"></choose-area-multi>-->
                                    <v-checkbox color="primary" v-model="model.specific_services" label="Specific Services"></v-checkbox>
                                    <choose-service-multi v-model="model.services" v-if="model.specific_services" label="Specific Services"></choose-service-multi>
                                    <v-select
                                            :items="['FIXED', 'PER_BOOKING', 'PER_HOUR', 'REVENUE_PERCENTAGE']"
                                            label="Prise Type"
                                            v-model="model.prise_type"
                                    >
                                    </v-select>
                                    <v-text-field
                                            v-model="model.prise_value"
                                            label="Prise Value"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import RidePage from "@/views/RidePage";
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseServiceMulti from "@/components/wasilni/input/ChooseServiceMulti";
    import ChooseAreaMulti from "@/components/wasilni/input/ChooseAreaMulti";

    export default {
        mixins: [socketEventsMixin],
        name: "Package Bonuses",
        title: "Package Bonuses",
        components: {ChooseAreaMulti, ChooseServiceMulti, ChooseDate, ChooseCaptainsMulti, CarInfo, DataTable, RidePage},
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'Min Rides', value: 'min_rides'},
                    {text: 'Min Bookings', value: 'min_bookings'},
                    {text: 'Min Online Hours', value: 'min_online_hours'},
                    {text: 'Min Rating', value: 'min_rating'},
                    {text: 'Min Reject Rate', value: 'min_reject_rate'},
                    {text: 'Min Cancellation Rate', value: 'min_cancellation_rate'},
                    {text: 'Specific Areas', value: 'specific_areas'},
                    {text: 'Specific Services', value: 'specific_services'},
                    {text: 'Prise Type', value: 'prise_type'},
                    {text: 'Prise Value', value: 'prise_value'},
                    {text: 'Actions', value: 'actions'},
                ],
                package: {
                    captains: [],
                    bonuses: []
                },
                loading: false,
                search: '',
                dialog: false,
                model: {},
                id: null
            };
        },
        mounted() {
            this.getData();
            this.id = this.$route.params.id;
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`bonus_package/${this.$route.params.id}`)
                    .then(res => this.package = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            timeSlices(id) {
                this.$router.push({
                    name: "Bonus Time Slices",
                    params: {"id": id}
                })
            },
            save() {
                this.loading = true;
                this.model.bonus_package_id = this.id;
                this.axios.post(this.api.ACTIONS.BONUS, this.model)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", 'success');
                    })
                    .catch(err => {
                        console.log(err);
                        window.getApp.$emit("SHOW_TOAST", err.message, "red");
                    })
                    .finally(() => this.loading = false);
            },

        }
    }
</script>

<style scoped>

</style>
